export const CONSUMER_MOBILE_CATEGORIES = [
  {
    name: 'Pay Monthly',
    id: 'postpaid',
  },
  {
    name: 'Prepaid',
    id: 'prepaid_retail_extra',
  },
  {
    name: 'Change your current plan',
    id: 'change_plan',
  },
];

export const BUSINESS_MOBILE_CATEGORIES = [
  {
    name: 'Pay Monthly',
    id: 'postpaid',
  },
];
